import { BaseGroup, BasePolicy, BaseProfile, BaseUser } from '@lib/core/model';

import { Device, SearchResult } from '../model';

export class SearchResultMapper {
  public static map(data: any): SearchResult {
    return data
      ? new SearchResult(
        SearchResultMapper.mapUsersResults(data.users),
        Array.isArray(data.devices)
          ? data.devices.map(
            (item) => new Device(item.uuid, item.vendor, item.model, item.alias, item.imei, item.serialNumber)
          )
          : [],
        SearchResultMapper.mapGroupsResults(data.groups),
        SearchResultMapper.mapPoliciesResults(data.policies),
        SearchResultMapper.mapProfilesResults(data.profiles)
      )
      : new SearchResult();
  }

  private static mapUsersResults(usersData: any): BaseUser[] {
    if (!(usersData instanceof Array)) {
      return [];
    }

    return usersData
      .filter((userData: any) => !!userData)
      .map(
        (userData: any) => new BaseUser(
          userData.id,
          userData.uuid,
          userData.firstName,
          userData.lastName,
          userData.email
        )
      );
  }

  private static mapGroupsResults(groupsData: any): BaseGroup[] {
    if (!(groupsData instanceof Array)) {
      return [];
    }

    return groupsData
      .filter((groupData: any) => !!groupData)
      .map((groupData: any) => new BaseGroup(groupData.id, groupData.name));
  }

  private static mapPoliciesResults(policiesData: any): BasePolicy[] {
    if (!(policiesData instanceof Array)) {
      return [];
    }

    return policiesData
      .filter((policyData) => !!policyData)
      .map(({ id, name, compatibility }) => new BasePolicy(id, name, compatibility));
  }

  private static mapProfilesResults(profilesData: any): BaseProfile[] {
    if (!(profilesData instanceof Array)) {
      return [];
    }

    return profilesData
      .filter((profileData: any) => !!profileData)
      .map((profileData: any) => new BaseProfile(profileData.id, profileData.uuid, profileData.name, profileData.type));
  }
}
